export class FastChargePersonaRequest {

    public nombreCompleto! : string;
    public correo! : string;
    public id_TipoDocumento! : number;
    public nroDocumento!: string;
    public id_Grupo!: number
}
